import APIService from './APIService';

export default {
  getDadosTOIsCobrancasPorInspecoesRealizadasMensais(competenciaDe, competenciaAte, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-cobrancas-irregularidades/get-dados-tois-cobrancas-por-inspecoes-realizadas?competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getDadosTOIsCobrancasPorInspecoesRealizadasAcumulados(competenciaDe, competenciaAte, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-cobrancas-irregularidades/get-dados-tois-cobrancas-por-inspecoes-realizadas-agrupados?competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getDadosTOIsCobrancasPorInspecoesRealizadasPorMunicipio(competenciaDe, competenciaAte, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-cobrancas-irregularidades/get-dados-tois-cobrancas-por-inspecoes-realizadas-por-municipio?competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
}